export interface ProgramStepDetail {
  id: string;
  order: number;
  title: string;
  description: string;
}

export const PROGRAM_STEP_DETAILS: ProgramStepDetail[] = [
  {
    id: "profile",
    order: 1,
    title: "Complete your profile!",
    description: "Update your personal and health details so our care team is ready for you.",
  },
  {
    id: "thyrocare",
    order: 2,
    title: "Book Your Blood & Urine Analysis",
    description:
      "Schedule the sample collection to analyze your biomarkers before the in-center visit.",
  },
  {
    id: "upload_reports",
    order: 3,
    title: "Upload previous reports",
    description: "Share historical health reports to help our team create better correlations.",
  },
  {
    id: "thrive_check",
    order: 4,
    title: "Fill Your Thrive Check Questionnaire",
    description: "A lifestyle and health questionnaire that unlocks the next steps (est. 30 mins).",
  },
  {
    id: "intake_call",
    order: 5,
    title: "Schedule Your 1 on 1 Health Assessment Call",
    description: "Review your medical history and current health status with our clinical team.",
  },
  {
    id: "neurowyzer",
    order: 6,
    title: "Brain Function Test",
    description:
      "A quick assessment to benchmark cognitive performance and support long-term mental agility.",
  },
  {
    id: "in_center",
    order: 7,
    title: "Schedule In-Center Visit",
    description: "Book the comprehensive in-clinic diagnostics session.",
  },
  {
    id: "longevity_consultation",
    order: 8,
    title: "Schedule Longevity Consultation",
    description: "Connect with our concierge to book your personalized longevity consultation.",
  },
];

export const PROGRAM_STEP_DETAILS_MAP = PROGRAM_STEP_DETAILS.reduce<Record<string, ProgramStepDetail>>(
  (map, detail) => {
    map[detail.id] = detail;
    return map;
  },
  {}
);
